import { ContentSource, PopulationProfile, EngineBaseline } from "./schema"
import { EngineRange, resolveEngineValues } from "./engine_values"

/** Shared by gameplay and candidate previews, with engine tuning supplied by the caller. */
export const resolvePopulationProfile = (source: ContentSource, race: string, baselines: Record<EngineBaseline, EngineRange>): { maxSpeed: number; hp: number; psych: Record<string, any>; scanDistanceTiles?: number } => {
    const seen = new Set<string>()
    const resolve = (id: string): any => {
        if (seen.has(id)) throw new Error(`Cyclic creature template: ${id}`)
        seen.add(id)
        const authored = source.sprites.creatures[id]
        const profile: PopulationProfile = source.profiles.population[id] || (!authored ? source.profiles.populationDefault : undefined)
        const base = profile ? resolveEngineValues<any>(profile, baselines) : resolve(authored.template)
        if (!authored) return base
        return { ...base, maxSpeed: authored.speed ?? base.maxSpeed, hp: authored.hp ?? base.hp,
            scanDistanceTiles: authored.scanDistanceTiles ?? base.scanDistanceTiles,
            psych: { ...base.psych, hostility: authored.hostility ?? base.psych.hostility } }
    }
    return resolve(race)
}
